// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Chip/NoClose.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Chip, ChipList} from '@sail/ui';
import {Container} from './common';

export const NoClose = () => (
  <Container>
    <ChipList>
      <Chip label="Amount" value="$10" />
      <Chip
        label="Age"
        value="18-24"
        onDropdown={() => {
          // eslint-disable-next-line no-alert
          alert('Dropdown function triggered');
        }}
      />
    </ChipList>
  </Container>
);
